import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { PAGE_SIZE_OPTIONS, PAGE_LENGTH, ITEMS_PER_PAGE, CURRENT_PAGE } from 'src/app/shared/constants/pagination.constants';
import { MatTableDataSource } from '@angular/material/table';
import { HolidaysService } from '../../services/holidays.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { HolidayCreateComponent } from '../holiday-create/holiday-create.component';
import { LoaderService } from 'src/app/auth/services/loader.service';


const dialogConfig= new MatDialogConfig();
dialogConfig.disableClose = true;
dialogConfig.autoFocus = true;

@Component({
  selector: 'app-holidays-details',
  templateUrl: './holidays-details.component.html',
  styleUrls: ['./holidays-details.component.css']
})
export class HolidaysDetailsComponent implements OnInit {
  
  @ViewChild('holidaysPaginator', {static: true}) holidaysPaginator: MatPaginator;

  holidaysDisplayedColumns: string[] = ['org_name', 'holiday_on', 'holiday_for'];
 
  public PAGE_SIZE_OPTIONS_DATA:number[] = PAGE_SIZE_OPTIONS;

  public page_length:number = PAGE_LENGTH;

  public items_per_page:number = ITEMS_PER_PAGE;

  public current_page:number = CURRENT_PAGE;
  
  public  holidaysDataSource:any;
  
  constructor(
    private dialog:MatDialog,
    private holidaysService:HolidaysService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private loaderService:LoaderService
  ) { }
  
  ngOnInit(): void {
    this.loadIcon();
    this.getHolidays();
  }
  
  loadIcon():void{
    this.matIconRegistry.addSvgIcon(
      "filter",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/SVG/filter.svg")
      );
    }
    
  getHolidays():void{
    this.loaderService.isTableLoding.next(true);

    let filterParams = this.addFilterParameters();

    this.holidaysService.getHolidays(filterParams).subscribe(
        (res:any)=>{
          // console.log("Responsive Data :: ",res);
          this.loaderService.isTableLoding.next(false);

          this.page_length = res.headers.get('X-Pagination-Total-Count');
          this.current_page = res.headers.get('X-Pagination-current-page');
          this.items_per_page = res.headers.get('X-Pagination-Per-Page');
          this.holidaysDataSource = new MatTableDataSource<any>(res.body);
          this.holidaysDataSource.paginator = this.holidaysPaginator;
      }
    );
  }

  createHoliday():void{
    dialogConfig.width ="40%";
    dialogConfig.data = {
      holiday_id : undefined
    };
    
    this.dialog.open(HolidayCreateComponent,dialogConfig);

    // UPDATE CONTACT DETAILS AFTER CREATING THE CONTACT
    this.dialog.afterAllClosed.subscribe(e=>{
      this.getHolidays();
    });
  }

  addFilterParameters():Object{
    let filterParams = {};
    filterParams['page']=this.current_page;
    filterParams["per-page"]=this.items_per_page;
    filterParams["sort"] = "-id";
    return filterParams;
  }

  handlePage(e?: any):void {
    if(e){
      this.current_page = e.pageIndex+1;
      this.items_per_page = e.pageSize;
      this.page_length = e.length;
    }
    this.getHolidays();
  }

}

